// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--3L5Rb";
export var disclaimer = "footer-module--disclaimer--2VBLD";
export var home = "footer-module--home--wnTrD";
export var pdf = "footer-module--pdf--3f0Xk";